<!-- 编辑 -->
<template>
    <div class="box">
        <!-- 路径 -->
        <div class="path">
            <img class="path_img" src="../../../../../assets/images/path.png"/>
            <div class="path_txt">运营管理系统 > 任务广告 > 积分墙 > 新增</div>
        </div>
        <!-- 编辑 -->
        <div class="work">
            <!--表单提交-->
            <el-form class="work_form" :model="wallData" ref="wallData" :rules="appWalls" label-position="right" label-width="150px">
                <el-form-item label="应用：" prop="appId">
                    <el-select v-model="wallData.appId" placeholder="请选择应用">
                        <el-option
                                v-for="item in apps"
                                :key="item.app_id"
                                :label="item.app_name"
                                :value="item.app_id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="积分墙标题：" prop="integralWallTitle">
                    <el-input v-model="wallData.integralWallTitle" clearable></el-input>
                </el-form-item>

                <el-form-item label="任务状态：" prop="integralWallStatus" required>
                    <el-radio-group v-model="wallData.integralWallStatus">
                        <el-radio v-model="wallData.integralWallStatus" :label="1">有效</el-radio>
                        <el-radio v-model="wallData.integralWallStatus" :label="0">无效</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button class="btn_confirm" type="primary" @click="submitForm('wallData')">确定</el-button>
                    <el-button class="btn_cancel" @click="onCancel">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // 应用对象数据
                wallData: {
                    integralWallStatus: 1,
                    appId:"",
                    integralWallTitle:""
                },
                // 校验规则
                appWalls: {
                    app_id: [
                        { required: true, message: '请选择应用', trigger: 'blur' }
                    ],
                    integral_wall_title: [
                        { required: true, message: '请积分墙标题', trigger: 'blur' },
                        { min: 1, max: 200, message: '长度在1～200个字符', trigger: 'blur' }
                    ]
                },
                apps:[],

            };
        },
        created() {
            this.getApps();
            // 获取参数
            let wallId = this.$route.params.integral_wall_id;
            // 加载对象
            if(wallId==null || wallId==undefined) {
                return;
            }
            this.getWall(wallId)
        },
        methods: {
            // 确定
            async submitForm(form) {
                // 验证表单数据
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        // 显示页面加载
                        const loading = this.$loading({
                            lock: true,
                            text: 'Processing ......',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)',
                            target: '.box'
                        });
                        // 修改应用
                        this.$api.apiAddIntegralWall(this.wallData).then (res => {
                            if (res.result === 1) {
                                // 请求成功
                                this.$message("新增应用成功", "success");
                                // 回退
                                this.$router.push('/running/task/wall/index');
                            } else {
                                this.$message(res.message, "warning");
                            }
                        });
                        // 关闭加载
                        loading.close();
                    }
                });
            },
            async getApps(){

                // 清空当前集合数据
                this.apps = [];
                // 调用接口
                let res = await this.$api.apiCommonApps(null);
                // 应用数据存进data
                this.apps = res.content;
            },
            // 取消
            async onCancel() {
                // 页面回退
                this.$router.go(-1);
            },
        },
    };
</script>

<style lang='scss' scoped>
    .box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex-wrap: nowrap;
        align-items: center;
        overflow: auto;
    }
    .path {
        margin: 10px 5px 0px 15px;
        padding: 0px;
        width: 100%;
        height: 20px;
        color: rgb(6, 6, 31);
        font-size: 1rem;
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        flex-direction: row;
        align-items: center;
    }
    .path_img {
        margin-right: 5px;
        height: 15px;
        width: 15px;
    }
    .path_txt {
        width: 100%;
        height: 20px;
        text-align: left;
    }
    .work {
        margin: 10px 5px 10px 5px;
        padding-top: 10px;
        width: 98%;
        height: calc(100% - 20px);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex-wrap: wrap;
        background: #fff;
        border-radius: 9px;
        align-items: center;
    }
    .work_form {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .el-form-item {
        margin: 20px 5px 0px 15px;
        width: 96%;
        height: 38px;
    }
    .el-input {
        width: 220px;
    }
    .el-select {
        width: 220px;
    }
    .el-button {
        width: 100px;
    }

</style>